import { useCallback } from "react";

import { postHTML } from "@/lib/aws-amplify/storage";
import type { LangCode } from "@/lib/gql/__generated__/graphql";

import { useCustomMutation } from "@/hooks/use-graphql-client";

import { RoomI18nArticleUpdate_DesignPage_Mutation } from "./mutation";

type Props = {
	hotelID: string;
	roomID: string;
	langCode: LangCode;
};

export const useRoomI18nArticleUpdateMutation = ({ hotelID, roomID, langCode }: Props) => {
	const { mutationFunc } = useCustomMutation(RoomI18nArticleUpdate_DesignPage_Mutation);

	const onUpdate = useCallback(
		async ({ articleHTML }: { articleHTML: string }) => {
			const { s3Object } = await postHTML({
				html: articleHTML,
				lang: langCode,
				hotelID,
				resourceID: roomID,
			});

			return await mutationFunc({
				variables: {
					input: {
						hotelID,
						roomID,
						article: s3Object,
						articleTitle: "",
						lang: langCode,
					},
				},
			});
		},
		[hotelID, langCode, mutationFunc, roomID],
	);

	return {
		onUpdate,
	};
};
